import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { isEpTradingWindowOpen } from '@uo/shared';
import { epAPI } from '../api/ep';

/** Follow the backend's effective hall state; local time is only the fallback. */
export function useEpTradingWindow(): boolean {
  const [open, setOpen] = useState(() => isEpTradingWindowOpen());
  const guideQuery = useQuery({
    queryKey: ['ep', 'guide', 'access'],
    queryFn: epAPI.getGuide,
    staleTime: 15_000,
    refetchInterval: 15_000,
  });

  useEffect(() => {
    if (guideQuery.data) {
      setOpen(guideQuery.data.hall_open);
      return;
    }
    const tick = () => setOpen(isEpTradingWindowOpen());
    tick();
    const id = window.setInterval(tick, 15_000);
    return () => window.clearInterval(id);
  }, [guideQuery.data]);
  return open;
}
